import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, deepPurpleMui, greyMui, orangeMui } from "@ryde/theme";

export const RebuildRouteDropdownWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "rebuild-route-dropdown-wrapper",
})<{ $isOpen: boolean }>`
  position: relative;

  .rebuild-route-button-container {
    display: flex;
    align-items: center;
    gap: 4px;

    .rebuild-route-dropdown-arrow {
      border-radius: 50%;
      padding: 4px;
      min-width: 24px;
      width: 24px;
      height: 24px;
      background-color: ${greyMui._300};
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-inline-end: 0;

      &:hover {
        background-color: ${greyMui._400};
      }

      &:disabled {
        background-color: ${greyMui._200};
        opacity: 0.6;
      }
    }
  }

  .rebuild-route-dropdown-arrow {
    transform: ${props => (props.$isOpen ? "rotate(180deg)" : "rotate(0deg)")};
    transition: transform 0.2s ease;
  }

  .custom-rebuild-indicator {
    color: ${orangeMui._600};
    font-weight: bold;
    margin-inline-start: 4px;
  }

  .rebuild-route-dropdown-menu {
    padding: 8px 0;
  }

  .rebuild-route-dropdown-header {
    padding: 6px 16px 3px 16px;
    font-size: 10px;
    font-weight: 500;
    color: ${greyMui._500};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-top: 1px solid ${greyMui._200};
    margin-top: 8px;

    &:first-child {
      border-top: none;
      margin-top: 0;
    }
  }

  .rebuild-route-dropdown-current-default {
    text-transform: none;
    letter-spacing: 0;
    font-size: 11px;
    font-weight: 600;
    color: ${greyMui._600};
  }

  .rebuild-route-dropdown-item {
    padding: 8px 16px;
    cursor: pointer;
    font-size: 15px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: opacity 0.3s ease;
    color: ${greyMui._900};

    &:hover:not(.disabled) {
      background-color: ${greyMui._50};
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    &.active {
      background-color: transparent;
      color: ${blueGreyMui.A700};
      font-weight: 600;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        inset-inline-start: 8px;
        inset-inline-end: 8px;
        top: 4px;
        bottom: 4px;
        background-color: ${blueGreyMui._50};
        border-radius: 6px;
        z-index: -1;
      }
    }
  }

  .rebuild-route-dropdown-icon {
    margin-inline-start: 4px;
    margin-inline-end: 8px;
    display: inline-flex;
    align-items: center;
    color: ${deepPurpleMui.A400};
  }

  .rebuild-route-dropdown-separator {
    margin: 8px 0;
  }

  .rebuild-route-dropdown-options {
    padding: 4px 0 0;
  }

  .rebuild-route-dropdown-option-item {
    display: flex;
    align-items: center;
    margin: 7px 0;
    gap: 11px; /* 8px default + 3px */
    padding-inline-start: 8px; /* Align with radio buttons */
    color: ${greyMui._900};

    .MuiFormControlLabel-label {
      color: ${greyMui._900};
    }
  }

  .rebuild-route-dropdown-option-item.rebuild-route-dropdown-default-action-checkbox {
    padding-inline-start: 0;
    margin-inline-start: 1px;
    margin-block: 0 4px;

    .MuiFormControlLabel-label {
      font-size: 13px;
    }
  }

  .rebuild-route-dropdown-radio-item {
    display: flex;
    align-items: center;
    margin: 4px 0;
    color: ${greyMui._900};

    .MuiFormControlLabel-label {
      color: ${greyMui._900};
    }
  }

  .rebuild-route-dropdown-button-container {
    padding: 4px 0 8px;
    border-top: 1px solid ${greyMui._200};
  }

  .rebuild-route-dropdown-reroute {
    white-space: normal;
    align-items: flex-start;
  }

  .rebuild-route-dropdown-reroute-label {
    flex: 1;
    min-width: 0;
    line-height: 1.3;
  }

  .default-provider-indicator {
    color: ${orangeMui._600};
    font-weight: bold;
    margin-inline-start: 4px;
  }
`;
